import type { FrontDeskOverview, FrontDeskRow } from "../bookings/frontDeskTypes";

/** `/design-preview` exists in dev and test builds only — never in production. */
export function isDesignPreviewEnabled(env: string | undefined): boolean {
  return env !== "production";
}

/** A believable front desk day (today, local time) for screenshots; no backend. */
export function previewOverview(now: Date): FrontDeskOverview {
  const at = (h: number, m: number) => new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m).toISOString();
  const row = (id: string, name: string, start: [number, number], end: [number, number], over: Partial<FrontDeskRow> = {}): FrontDeskRow => ({
    id,
    startTime: at(...start),
    endTime: at(...end),
    status: "CONFIRMED",
    customer: { name, phone: "9911 2233", email: null },
    service: { id: "s1", name: "Эрэгтэй үс засалт" },
    staff: { id: "st1", name: "Сараа" },
    paymentSummary: { price: 40000, paid: 40000, balance: 0 },
    awaitingPayment: null,
    refundOwed: null,
    code: id.toUpperCase().padEnd(8, "0").slice(0, 8),
    reachable: true,
    customerReply: null,
    changeRequest: null,
    ...over,
  });
  const awaiting = row("b3", "Тэмүүлэн Баатар", [11, 0], [11, 45], {
    status: "PENDING",
    service: { id: "s2", name: "Үс будалт, засалт" },
    staff: { id: "st2", name: "Номин-Эрдэнэ" },
    paymentSummary: { price: 120000, paid: 0, balance: 120000 },
    awaitingPayment: { payBy: at(12, 0), overdue: false, legacy: false },
  });
  const today = [
    row("b1", "Болд", [9, 30], [10, 15], { status: "COMPLETED" }),
    row("b2", "Номин", [10, 30], [11, 15], { paymentSummary: { price: 40000, paid: 0, balance: 40000 } }),
    awaiting,
    row("b4", "Сэлэнгэ", [13, 0], [14, 0], {
      service: { id: "s3", name: "Хумс" },
      paymentSummary: { price: 65000, paid: 20000, balance: 45000 },
    }),
    row("b5", "Ану", [15, 0], [15, 30], {
      service: { id: "s4", name: "Зөвлөгөө" },
      paymentSummary: { price: 0, paid: 0, balance: 0 },
    }),
  ];
  return {
    today,
    awaitingPayment: [awaiting],
    refundsOwed: [],
    callList: [today[3]],
    changeRequests: [],
    counts: { overduePayments: 0, awaitingPayments: 1, refundsOwed: 0, callList: 1, changeRequests: 0 },
  };
}
